<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
// Loading some plugin css asynchronously
import('sweetalert2/dist/sweetalert2.css')
import('vue-notifyjs/themes/default.css')
import {mapState, mapActions, mapGetters} from 'vuex'

export default {
  computed: {
    ...mapState(['notifications']),
    ...mapGetters(['isAuthenticated'])
  },
  created () {
    this.unsubscribe = this.$store.subscribe(({type, payload}, state) => {
      if (type === 'PREPEND_NOTIFICATION') {
        this.notify(payload.type, payload.message)
      }
    });

    this.$store.commit('LAST_UPDATE_RENEW');

    window.setInterval(() => {
      if (this.isAuthenticated) {
        this.jobsFetchUpdates();
        console.log('updatin')
      }
    }, 5000)

  },
  beforeDestroy () {
    this.unsubscribe();
  },
  methods: {
    ...mapActions(['jobsFetchUpdates']),
    notify (type, message) {
      this.$notify(
        {
          component: {
            template: `<span>${message}</span>`
          },
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
    }
  }
}
</script>
<style lang="scss">
.notifications.vue-notifyjs {
  .notification-list-move {
    transition: transform 0.3s, opacity 0.4s;
  }

  .notification-list-item {
    display: inline-block;
    margin-right: 10px;

  }

  .notification-list-enter-active, .notification-list-leave-active {
    transition: opacity 0.4s;
  }

  .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
  {
    opacity: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue